import { HttpErrorResponse } from '@angular/common/http';
import { PaymentAccount } from '@arc/unified-payments-frontend/shared-payment';
import { createActionGroup, props } from '@ngrx/store';

export const HostedPaymentsSelectPaymentMethodPaymentAccountsActions =
  createActionGroup({
    source: 'Hosted Payments Select Payment Method Component Payment Accounts',
    events: {
      'Payment Account Created': props<{
        payload: PaymentAccount;
      }>(),
      'Create Payment Account Error': props<{
        error: HttpErrorResponse;
      }>(),
    },
  });
